import React from "react";
import { LegacyRepoPage } from "./LegacyRepoPage";

export function LegacyContractsPage() {
  return <LegacyRepoPage />;
}